import React, { useState, useEffect } from "react";
import {
  Button,
  Input,
  InputNumber,
  Divider,
  Row,
  Col,
  Form,
  Modal,
  message,
  Card,
  Spin,
  Tabs,
  Table,
  Avatar,
} from "antd";
import IntlMessages from "../../../util/IntlMessages";
import ds from "../../../Services/DataServices";
import Skeleton from "react-loading-skeleton";
import { useHistory } from "react-router-dom";
import {
  HistoryOutlined,
  ArrowRightOutlined,
  FundViewOutlined,
  KeyOutlined,
} from "@ant-design/icons";
import { useDispatch, useStore, useSelector } from "react-redux";
import PromoCodePic1 from "../../../assets/images/promo-code-1.svg";
import PromoCodePic2 from "../../../assets/images/promo-code-2.svg";
import PromoCodePic3 from "../../../assets/images/promo-code-3.svg";
import { userLogOut } from "../../../appRedux/actions/Auth";
import {
  loadPromoCodes,
  loadPromoCodesModal,
  loadPromoCodesCreatedNbr,
} from "../../../appRedux/actions/Products";
import { BEHAVIOUR_TYPE } from "../../../Services/DataServices";
import { getRandomInt, notAllowMsgCheck } from "../../../appRedux/actions";

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 20 },
  },
};

function evenOrOdd(num) {
  //for string length take string
  if (num % 2 == 0) {
    //and replace numm with string.length here
    return "even";
  } else {
    return "odd";
  }
}

const columns = [
  {
    title: <IntlMessages id="products.promoadd.promocodes" />,
    dataIndex: "codeName",
    key: "codeName",
    render: (text, record) => {
      return (
        <div>
          <strong>
            <h3 style={{ color: "#1890ff", fontWeight: "bold" }}>
              <KeyOutlined style={{ fontSize: "xx-large", color: "#41af4b" }} />
              <span>{` ${text}`}</span>
            </h3>
          </strong>
          <p style={{ fontWeight: "normal", marginLeft: 30, marginTop: -10 }}>
            {`${
              record.nbrOfRedemptions == 0
                ? "unlimited"
                : record.nbrOfRedemptions
            } uses, ${record.nbrOfUsed} redeemed`}
          </p>
          {record.expired && (
            <p
              style={{ fontWeight: "lighter", marginLeft: 30, marginTop: -14 }}
            >
              <IntlMessages id="promo.promocode.expired" />
            </p>
          )}
        </div>
      );
    },
  },
  {
    title: <IntlMessages id="products.promoadd.genby" />,
    dataIndex: "genBy",
    key: "genBy",
    render: (text, record, key) => {
      let isEvenOrOdd = evenOrOdd(key);
      let nameLetter = "";
      let name = "";
      let firstName = record.userFirstName;
      let lastName = record.userLastName;
      name = firstName + " " + lastName;
      let letterFirst = firstName ? firstName.charAt(0).toUpperCase() : "";
      let letterSecond = lastName ? lastName.charAt(0).toUpperCase() : "";
      nameLetter = letterFirst + letterSecond;
      return (
        <>
          <div className="gx-module-list-icon">
            <Row gutter={12}>
              <Col>
                <div className="gx">
                  <Avatar
                    style={{ fontWeight: "bold" }}
                    className={`gx-avatar gx-bg-${
                      isEvenOrOdd == "even" ? "green" : "blue"
                    } gx-size-46 mr-10`}
                  >
                    {nameLetter}
                  </Avatar>
                </div>
              </Col>

              <Col>
                <div className="gx-module-list-content">
                  <div className="gx-mail-user-des">
                    <span className="gx-sender-name">{name}</span>

                    <span className="gx-toolbar-separator">&nbsp;</span>

                    <span className="vd-flag sm:hidden">{record.role}</span>
                  </div>
                  <div className="gx-message">
                    <p className="gx-text-truncate"> {text}</p>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </>
      );
    },
  },
];

// const columnsProd = [
//   {
//     title: <IntlMessages id="products.promoadd.prods" />,
//     dataIndex: "name",
//     key: "name",
//     render: (text, record) => {
//       //const [form] = Form.useForm();
//       // const viewProduct = async (tagid) => {
//       //   history.push(`/dashboard/products/main/listing/tagid/${tagid}`);
//       // };
//       return (
//         <div>
//           <h3 style={{ color: "#1890ff" }}>
//             <strong>{text}</strong>
//           </h3>
//         </div>
//       );
//     },
//   },
//   {
//     title: <IntlMessages id="products.promoadd.retprice" />,
//     dataIndex: "retailPrice",
//     align: "right",
//     key: "retailPrice",
//     render: (text, record) => {
//       //const [form] = Form.useForm();
//       const viewProduct = async (tagid) => {
//         // history.push(`/dashboard/products/main/listing/tagid/${tagid}`);
//       };
//       return (
//         <div>
//           <h3>{`EUR ${record.discountPrice}`}</h3>
//           <p style={{ textDecoration: "line-through" }}>{`EUR ${text}`}</p>
//         </div>
//       );
//     },
//   },
// ];

// const dataProd = [
//   {
//     name: "Cap",
//     id: "1&jasd-asdjh",
//     retailPrice: 14.0,
//     discountPrice: 11.5,
//   },
//   {
//     name: "Necklace",
//     id: "2&jasd-asdjh",
//     retailPrice: 12.09,
//     discountPrice: 9.5,
//   },
//   {
//     name: "Shirt",
//     id: "3&jasd-asdjh",
//     discountPrice: 111.5,
//     retailPrice: 120.0,
//   },
// ];

const { TabPane } = Tabs;

const PromoCodes = (props) => {
  const id = props.id;
  const name = props.name;
  const outlets =
    props.outlets && props.outlets.length > 0 ? props.outlets : [];
  const duration =
    props.duration && props.duration.length > 0 ? props.duration : [];
  const history = useHistory();
  const store = useStore();
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const getReduxIsShowModal = useSelector(
    ({ Products }) => Products.promoCodeModal
  );

  const getReduxPromoCodes = useSelector(({ Products }) => Products.promoCodes);

  const [getNbrOfFields, setNbrOfFields] = useState([]);
  const [getCopyNbrOfFields, setCopyNbrOfFields] = useState([]);
  const [getIsSpinning, setIsSpinning] = useState(false);
  const [getIsPromoCodeVisible, setIsPromoCodeVisible] = useState(false);
  const [getCodeWillCreatedNbr, setCodeWillCreatedNbr] = useState([]);
  const [getStartDate, setStartDate] = useState("");
  const [getEndDate, setEndDate] = useState("");
  const [getPromoCodeDetail, setPromoCodeDetail] = useState([]);

  React.useEffect(() => {
    if (duration && duration.length > 1) {
      let startDate = duration[0].format("DD/MM/YYYY");
      let endDate = duration[1].format("DD/MM/YYYY");
      setStartDate(startDate);
      setEndDate(endDate);
    }
  }, [duration]);

  React.useEffect(() => {
    let supposedArr = [
      getRandomInt(1000000),
      getRandomInt(1000000),
      getRandomInt(1000000),
    ];
    setNbrOfFields(supposedArr);
    if (id) {
      setIsSpinning(true);
      let body = {
        PromotionID: id,
      };
      getPromotionCodes(body);
    }
  }, []);

  async function getPromotionCodes(body) {
    const getCodes = ds.getPromoCodes(body, BEHAVIOUR_TYPE.GET);
    await getCodes
      .then((res) => {
        setIsSpinning(false);
        if (res.data.data.length > 0) {
          let data = res.data.data;
          setCopyNbrOfFields(data);

          // let definedPromoCodes = [];
          // // data.map((e) => {
          // //   definedPromoCodes.push(e.promoCodeID);
          // // });
          // // setNbrOfFields(definedPromoCodes);

          //setting codeValues
          // let definedCodes = data;
          // if (definedCodes.length > 0) {
          //   definedCodes.map((e) => {
          //     let codename = `code${e.promoCodeID}`;
          //     let nbrRedemption = `number${e.promoCodeID}`;

          //     form.setFieldsValue({ [codename]: e.codeName });
          //     if (e.nbrOfRedemptions != 0) {
          //       form.setFieldsValue({ [nbrRedemption]: e.nbrOfRedemptions });
          //     }
          //   });
          // }
        }
      })
      .catch((e) => {
        notAllowMsgCheck(e);
        setIsSpinning(false);
      });
  }

  async function getPromotionCodesDetails(body) {
    const getCodeDetail = ds.getPromoCodeDetailsService(
      body,
      BEHAVIOUR_TYPE.GET
    );
    await getCodeDetail
      .then((res) => {
        setIsSpinning(false);
        if (res.promoCodes && res.promoCodes.length > 0) {
          setPromoCodeDetail(res.promoCodes);
        }
      })
      .catch((e) => {
        notAllowMsgCheck(e);
        setIsSpinning(false);
      });
  }

  const onFinish = (values) => {
    // ;
    try {
      dispatch(loadPromoCodesModal(false));
      if (values != undefined) {
        let formValues = Object.entries(values);
        let formKeys = [];
        let body = [];

        //collecting keys to submit codename and their respective nbr of redemption
        formValues &&
          formValues.length > 0 &&
          formValues.map((e) => {
            if (e[0].includes("code") && e[1] != undefined) {
              if (e[1] != "") {
                let fKey = e[0].split("code")[1];
                let isCodeDefined = false;
                //check for already saved promocode
                if (getCopyNbrOfFields.length > 0) {
                  let exist = getCopyNbrOfFields.filter(
                    (a) => a.promoCodeID == fKey
                  );
                  isCodeDefined = exist.length > 0 ? true : false;
                }
                if (!isCodeDefined) {
                  return formKeys.push(fKey);
                }
              }
            }
          });

        if (formKeys && formKeys.length > 0) {
          //collecting code names & numbers for body posting
          formKeys.map((e) => {
            let codename = `code${e}`;
            let nbrRedemption = `number${e}`;

            let valueCodeName = formValues.filter(
              (a) => a[0] == codename
            )[0][1];
            let valueNbrRedemption = formValues.filter(
              (a) => a[0] == nbrRedemption
            )[0][1];

            let bodyObject = {
              CustomPromoCode: valueCodeName,
              NumberOfRedemption:
                valueNbrRedemption == undefined ? 0 : valueNbrRedemption,
            };

            body.push(bodyObject);
          });

          dispatch(loadPromoCodes(body));
        }
      }
    } catch (e) {
      message.info("phat gai");
    }
  };

  function deleteRow(e) {
    let supposedArr = getNbrOfFields.filter((a) => a !== e);
    setNbrOfFields(supposedArr);
  }

  function addRow() {
    let oneMore = getRandomInt(10000000);
    setNbrOfFields(getNbrOfFields.concat(oneMore));
    // let isExist = getNbrOfFields.findIndex((a) => a == oneMore.toString());
    // if (isExist != -1) {
    //   oneMore = oneMore + 1;
    //   isExist = getNbrOfFields.findIndex((a) => a == oneMore.toString());
    //   if (isExist != -1) {
    //     oneMore = oneMore + 1;
    //     isExist = getNbrOfFields.findIndex((a) => a == oneMore.toString());
    //     if (isExist != -1) {
    //       oneMore = oneMore + 1;
    //       isExist = getNbrOfFields.findIndex((a) => a == oneMore.toString());
    //       if (isExist != -1) {
    //         oneMore = oneMore + 1;
    //       }
    //     }
    //   }
    // }
  }

  function handleCancel() {
    dispatch(loadPromoCodesModal(false));
    // setIsPromoCodeVisible(false);
  }

  function showPromoCode() {
    // setIsPromoCodeVisible(true);
    dispatch(loadPromoCodesModal(true));
  }

  const PromoCodeAddModal = () => {
    return (
      <Modal
        title={
          <Row>
            <h1 className="custom-addpromo-promocodehead">
              <IntlMessages id="products.promoadd.addpromocode" />
            </h1>
            <p className="custom-addpromo-promocodedesc">
              <IntlMessages id="products.promoadd.promocodedesc" />
            </p>
          </Row>
        }
        visible={getReduxIsShowModal}
        onCancel={handleCancel}
        centered={true}
        footer={null}
        cancelButtonProps={{
          className: "dk-btn-cancel",
        }}
        bodyStyle={{ width: 500 }}
      >
        <div className="custom-promoadd-maindiv">
          <Divider style={{ borderColor: "#bfbebe" }} />

          <Row>
            <Col md={12} xs={6}>
              <p className="custom-addpromo-head1">
                <IntlMessages id="products.promoadd.promocodehead1" />
              </p>
            </Col>

            <Col md={12} xs={6}>
              <p className="custom-addpromo-head2">
                <IntlMessages id="products.promoadd.promocodehead2" />
              </p>
              <p className="custom-addpromo-subhead">
                <IntlMessages id="products.promoadd.promocodesubhead" />
              </p>
            </Col>
          </Row>

          <Divider style={{ borderColor: "#bfbebe" }} />
          {/* <CustomScrollbars className="gx-module-content-scroll">
          </CustomScrollbars>
        */}
          <Form
            {...formItemLayout}
            form={form}
            name="promoCodeForm"
            onFinish={onFinish}
            // onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            {getNbrOfFields.map((e, key) => {
              let isShow = true;
              // if (getCopyNbrOfFields.length > 0) {
              //   let exist = getCopyNbrOfFields.filter(
              //     (a) => a.promoCodeID == e
              //   );
              //   isShow = exist.length > 0 ? false : true;
              // }
              let example =
                key == 0
                  ? "Enter Promo Code, eg. FBFans01"
                  : key == 1
                  ? "Enter Promo Code, eg. InstaFans01"
                  : key == 2
                  ? "Enter Promo Code, eg. TwitterFans01"
                  : "Enter Promo Code, eg. WhatsAppFans01";
              return (
                <>
                  {/* <Row style={{ marginTop: "22px", marginBottom: "-14px" }}> */}
                  <Row>
                    <Col md={12} xs={6}>
                      <Form.Item
                        className="ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment"
                        name={`code${e}`}
                        key={`code${e}`}
                        rules={[
                          {
                            required: false,
                            validator(_, value) {
                              if (value != undefined || value == "") {
                                if (value.indexOf(" ") >= 0) {
                                  return Promise.reject(
                                    new Error("Please Remove Space")
                                  );
                                }
                                if (
                                  getCopyNbrOfFields &&
                                  getCopyNbrOfFields.length > 0
                                ) {
                                  let data = getCopyNbrOfFields.filter(
                                    (a) => a.codeName == value
                                  );
                                  if (data.length > 0) {
                                    return Promise.reject(
                                      new Error("This code is already saved")
                                    );
                                  }
                                }
                                if (key > 0) {
                                  let showError = false;
                                  getNbrOfFields.map((f, i) => {
                                    if (i != key) {
                                      let name = form.getFieldValue(`code${f}`);
                                      if (value == name) {
                                        showError = true;
                                      }
                                    }
                                  });
                                  if (showError) {
                                    return Promise.reject(
                                      new Error("This code is already present")
                                    );
                                  } else {
                                    return Promise.resolve();
                                  }
                                } else {
                                  return Promise.resolve();
                                }
                              } else {
                                return Promise.resolve();
                              }
                            },
                          },
                        ]}
                      >
                        <Input
                          // disabled={!isShow}
                          placeholder={example}
                          style={{ width: "100%", height: "45px" }}
                        />
                      </Form.Item>
                    </Col>

                    <Col md={8} xs={6}>
                      <Form.Item
                        className="ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment"
                        name={`number${e}`}
                        key={`number${e}`}
                      >
                        <InputNumber
                        type="number"
                          // disabled={!isShow}
                          style={{ width: "100%", height: "45px" }}
                          placeholder="∞"
                          min={1}
                          max={100000000000}
                          step={1}
                          // onChange={onChangeMark}
                        />
                      </Form.Item>
                    </Col>

                    {getNbrOfFields.length > 1 && isShow && (
                      <Col md={4} xs={4}>
                        <a
                          onClick={() => {
                            deleteRow(e);
                          }}
                          className="trash-icon-btn"
                        >
                          <i
                            disabled
                            className="icon icon-trash"
                            style={{ fontSize: "20px" }}
                          />
                        </a>
                      </Col>
                    )}
                  </Row>

                  <Divider style={{ borderColor: "#bfbebe" }} />
                </>
              );
            })}
          </Form>

          <Row>
            <Col md={12}>
              <Button
                className="dk-btn-add"
                type="primary"
                onClick={() => {
                  addRow();
                }}
              >
                <IntlMessages id="products.promoadd.addmorecode" />
              </Button>
            </Col>

            <Col md={12} className="custom-promocode-savebtn">
              <Form form={form} name="promoCodeForm" onFinish={onFinish}>
                <Form.Item>
                  <Button
                    className="dk-btn-add"
                    htmlType="submit"
                    type="primary"
                  >
                    <IntlMessages id="products.promoadd.savbtn" />
                  </Button>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </div>
      </Modal>
    );
  };

  const PromoCodeShowModal = () => {
    return (
      <Modal
        visible={getIsPromoCodeVisible}
        title={
          <Row justify="center">
            <h1>
              <strong>{name}</strong>
            </h1>
          </Row>
        }
        cancelButtonProps={{
          className: "dk-btn-cancel",
        }}
        onCancel={() => setIsPromoCodeVisible(false)}
        centered={true}
        width={"800px"}
        footer={null}
      >
        <Spin
          tip={<IntlMessages id="products.promoadd.loadpromocodes" />}
          spinning={getIsSpinning}
          size="large"
        >
          <div className="custom-promoadd-maindiv">
            <Row justify="center">
              <Col style={{ textAlign: "center" }} span={8}>
                <h2>
                  <IntlMessages id="products.promoadd.dur" />
                </h2>
                <br />
                <h3 style={{ marginTop: -20 }}>
                  {`${getStartDate} to ${getEndDate}`}
                </h3>
              </Col>
              <Col style={{ textAlign: "center" }} span={8}>
                <h2>
                  <IntlMessages id="products.promoadd.ava" />
                </h2>
                <br />
                <h3 style={{ marginTop: -20 }}>
                  {`${outlets.length} `}
                  {outlets.length > 1 ? (
                    <IntlMessages id="products.promoadd.out" />
                  ) : (
                    <IntlMessages id="products.addpricebook.outlets" />
                  )}
                </h3>
              </Col>
              <Col style={{ textAlign: "center" }} span={8}>
                <h2>
                  <IntlMessages id="products.promoadd.custar" />
                </h2>
                <br />
                <h3 style={{ marginTop: -20 }}>
                  <IntlMessages id="products.promoadd.tarcard2" />
                </h3>
              </Col>
            </Row>

            <Tabs defaultActiveKey="2" size="large">
              {/* <TabPane tab={<IntlMessages id="products.promoadd.buy1" />} key="1">
              <Table
                className="gx-table-responsive"
                columns={columnsProd}
                dataSource={dataProd}
              />
            </TabPane> */}
              <TabPane
                style={{ fontWeight: "bold" }}
                tab={<IntlMessages id="products.promoadd.withpromocode" />}
                key="2"
              >
                <Table
                  className="gx-table-responsive"
                  columns={columns}
                  dataSource={getPromoCodeDetail}
                />
              </TabPane>
            </Tabs>
          </div>
        </Spin>
      </Modal>
    );
  };

  return (
    <>
      <Spin
        tip={<IntlMessages id="products.promoadd.loadpromocodes" />}
        spinning={getIsSpinning}
        size="large"
      >
        {getReduxIsShowModal ? (
          <>
            <PromoCodeAddModal />
          </>
        ) : (
          <>
            {getCopyNbrOfFields.length > 0 && (
              <Row>
                <Col span={24}>
                  <p className="custom-promocode-created">
                    <FundViewOutlined />{" "}
                    <a
                      className="custom-addedcodesview"
                      onClick={() => {
                        setIsSpinning(true);
                        setIsPromoCodeVisible(true);
                        getPromotionCodesDetails({ PromotionID: id });
                      }}
                    >
                      {`${getCopyNbrOfFields.length} ${
                        getCopyNbrOfFields.length > 1
                          ? " Promo Codes "
                          : " Promo Code "
                      }`}
                    </a>
                    <IntlMessages id="products.promoadd.nbrofcodecreated" />
                  </p>
                </Col>
              </Row>
            )}

            {/* getCodeWillCreatedNbr */}
            {getReduxPromoCodes.length > 0 ? (
              <>
                <Row>
                  <Col span={24}>
                    <p className="custom-promocode-willcreated">
                      <HistoryOutlined />
                      {` `}
                      <span style={{ color: "#6692b0" }}>
                        <strong>{`"${getReduxPromoCodes.length}"`}</strong>
                      </span>
                      <IntlMessages id="products.promoadd.nbrofcodewillcreated" />
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col span={24} style={{ marginBottom: "30px" }}>
                    <Button
                      className="custom-addpromo-promocodebtn"
                      onClick={showPromoCode}
                    >
                      <IntlMessages id="products.promoadd.addpromocodes" />
                    </Button>
                  </Col>
                </Row>
              </>
            ) : (
              <>
                <div>
                  <Card className="custom-col-text-center">
                    <Row>
                      <Col md={8}>
                        <Row>
                          <Col md={12} xs={24} className="custom-col-text-center">
                            <img src={PromoCodePic1} alt="" />{" "}
                            <p className="custom-addpromo-cardpromotext">
                              <IntlMessages id="products.promoadd.cardpromocodetex1" />{" "}
                            </p>
                          </Col>
                          <Col md={12} xs={24}>
                            <h2 className="custom-addpromo-arrowcardcode ">
                              <ArrowRightOutlined />
                            </h2>
                          </Col>
                        </Row>
                      </Col>
                      <Col md={8}>
                        {" "}
                        <Row>
                          <Col md={12} xs={24} className="custom-col-text-center">
                            <img src={PromoCodePic2} alt="" />{" "}
                            <p className="custom-addpromo-cardpromotext ">
                              <IntlMessages id="products.promoadd.cardpromocodetex2" />{" "}
                            </p>
                          </Col>
                          <Col md={12} xs={24}>
                            <h2 className="custom-addpromo-arrowcardcode ">
                              <ArrowRightOutlined />
                            </h2>
                          </Col>
                        </Row>
                      </Col>
                      <Col md={8}>
                        {" "}
                        <Row>
                          <Col md={24} className="custom-col-text-center">
                            <img src={PromoCodePic3} alt="" />{" "}
                            <p className="custom-addpromo-cardpromotext ">
                              <IntlMessages id="products.promoadd.cardpromocodetex3" />{" "}
                            </p>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Button
                      className="custom-addpromo-promocodebtn"
                      onClick={showPromoCode}
                    >
                      <IntlMessages id="products.promoadd.addpromocodes" />
                    </Button>
                  </Card>

                  {/* <Row>
                    <Col span={24}>
                      <div>
                        <Card>
                          <Row>
                            <Col span={6} pull={4}>
                              <img
                                style={{ marginLeft: "126px" }}
                                src={PromoCodePic1}
                                alt=""
                              />
                            </Col>

                            <Col span={3}>
                              <h2 className="custom-addpromo-arrowcardcode">
                                <ArrowRightOutlined />
                              </h2>
                            </Col>

                            <Col span={6} pull={5}>
                              <img
                                style={{ marginLeft: "126px" }}
                                src={PromoCodePic2}
                                alt=""
                              />
                            </Col>

                            <Col span={3}>
                              <h2 className="custom-addpromo-arrowcardcode">
                                <ArrowRightOutlined />
                              </h2>
                            </Col>

                            <Col span={6} pull={5}>
                              <img
                                style={{ marginLeft: "126px" }}
                                src={PromoCodePic3}
                                alt=""
                              />
                            </Col>
                          </Row>

                          <Row>
                            <Col span={8}>
                              <p className="custom-addpromo-cardpromotext">
                                <IntlMessages id="products.promoadd.cardpromocodetex1" />
                              </p>
                            </Col>

                            <Col span={8}>
                              <p className="custom-addpromo-cardpromotext">
                                <IntlMessages id="products.promoadd.cardpromocodetex2" />
                              </p>
                            </Col>

                            <Col span={8}>
                              <p className="custom-addpromo-cardpromotext">
                                <IntlMessages id="products.promoadd.cardpromocodetex3" />
                              </p>
                            </Col>
                          </Row>

                          <Row>
                            <Col span={8}></Col>
                            <Col span={8}>
                              <Button
                                className="custom-addpromo-promocodebtn"
                                onClick={showPromoCode}
                              >
                                <IntlMessages id="products.promoadd.addpromocodes" />
                              </Button>
                            </Col>
                            <Col span={8}></Col>
                          </Row>
                        </Card>
                      </div>
                    </Col>
                  </Row> */}
                </div>
              </>
            )}
          </>
        )}
        <PromoCodeShowModal />
      </Spin>
    </>
  );
};

// ReactDOM.render(<PromoCodes />, mountNode);

export default PromoCodes;
